import classNames from "classnames";
import React from "react";
import { Link } from "tsi-common-react/src/common/Link";

import { IMenuPageLink } from "../../menu.interface";

interface IProps {
    linkObject: IMenuPageLink;
    isMobile: boolean;
    linkID: number;
}

export const PageLink = (props: IProps) => {
    const linkClass = classNames({
        "site-nav__main-menu-item": !props.isMobile,
        "main-dropdown-menu__mobile": props.isMobile,
        "main-dropdown-menu__mobile-link": props.isMobile,
        [`main-dropdown-menu__mobile--${props.linkObject.value.page.slug}`]:
            props.isMobile,
    });
    return (
        <Link
            key={props.linkID}
            // TODO(i18n): override_title comes from CMS and should be translated there, not here
            title={props.linkObject.value.override_title}
            className={linkClass}
            href={props.linkObject.value.page.url}
            target={props.linkObject.value.open_in_new_tab ? "_blank" : "_top"}
            rel="noreferrer"
        >
            {/* TODO(i18n): override_title comes from CMS and should be translated there, not here */}
            {props.linkObject.value.override_title}
        </Link>
    );
};
